/**************************************************
 * Nombre:       Home_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TextoTitulo from "./SubComponentes/TextoTitulo";
import Tarjeta_Categorias from "../../Tarjetas/Tarjeta_Categorias";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import agave from '../../../Recursos/Temporales/agave.svg'
import maguey from '../../../Recursos/logo_maguey.png'
import conejos from '../../../Recursos/logo_conejos.png'
import matatlan from '../../../Recursos/logo_matatlan.png'
import montelobos from '../../../Recursos/logo_montelobos.png'
import pedro from '../../../Recursos/logo_pedro.png'
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useNavigate} from "react-router";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Categorias = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [marcas, setMarcas] = useState([]);


    useEffect(() => {


        let arr = [
            {
                nombre: 'Tipo de Agave',
                id: 'Tipo',
                items: cData.tipos,
                img: agave,
                md: 6
            },
            {
                nombre: 'Tipo de Reserva',
                id: 'Reserva',
                items: cData.reservas,
                img: agave
            },
            {
                nombre: 'Madurez del Agave',
                id: 'Madurez',
                items: cData.madureces,
                img: agave
            },
            {
                nombre: 'Agave',
                id: 'Origen',
                items: cData.origenes,
                img: agave
            },
        ]

        setItems(arr)
        setMarcas(cData.marcas)

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#EAEEF0',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, pt: 6, pb: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <TextoTitulo texto={'ESCOGE'} titulo={'CATEGORIAS'} negrita={'POPULARES'}/>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={4}
                            sx={{mt: 4}}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Categorias item={item}/>
                                </Grid>
                            ))}

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <Splide
                                aria-label="My Favorite Images" style={{width: '100%'}}
                                options={{
                                    autoplay: true,
                                    speed: 1500,
                                    rewind: true,
                                    perPage:sCell ? 3 : 8,
                                    arrows: false,
                                    pagination: false,
                                    width: '100%',
                                    drag: false,
                                    interval: 8000,
                                    noDrag: true,
                                    type: 'loop',
                                    gap: sCell ? 10 : 40


                                }}
                            >

                                {marcas.map((item, index) => {
                                    return (
                                        <SplideSlide key={`qse${index}`}>
                                            <Grid
                                                onClick={() => navigate('/Catalogo/Palabra/' + item.nombre)}
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'center'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                                sx={{
                                                    height: 120,
                                                    cursor: 'pointer',
                                                    ':hover': {
                                                        scale: 1.1
                                                    }
                                            }}

                                            >

                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <img src={item.img} width={'100%'}/>
                                                </Grid>

                                            </Grid>

                                        </SplideSlide>
                                    )
                                })}


                            </Splide>


                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Categorias

const logos = [maguey, conejos, matatlan, montelobos, pedro]